import moment from "moment";

/**
 * Processes subscription data and calculates totals by plan and platform
 * @param {Array} values - Array of subscription arrays [elavonSubs, appleSubs, androidSubs, stripeSubs]
 * @param {Object} range - Date range object with startDate and endDate
 * @param {string} plan - Plan filter ("ALL", "COACH", "STUDENT", or specific productId)
 * @returns {Array} Processed totals result array
 */
export const processSubscriptions = (values, range, plan) => {
  let totalsResult = [
    {
      plan: "Pro Lite - Monthly",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Pro Lite - Annual",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Plus - Monthly",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Plus - Annual",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Premium - Monthly",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Premium - Annual",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Enterprise Master",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Staff Account",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "3D Player - Monthly",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "3D Player - Annual",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Total Accounts",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
  ];

  const pIndex = {
    sportsbox_pro_lite_monthly: 0,
    sportsbox_pro_lite_annually: 1,
    sportsbox_pro_plus_monthly: 2,
    sportsbox_pro_plus_annually: 3,
    sportsbox_pro_premium_monthly: 4,
    sportsbox_pro_premium_annually: 5,
    sportsbox_enterprise_master: 6,
    sportsbox_enterprise_staff: 7,
    sportsbox_student_lite_monthly: 8,
    sportsbox_student_lite_annually: 9,
  };

  values.forEach((subscriptions, index) => {
    let platformKey = "elavon";
    if (index === 1) {
      platformKey = "apple";
    }
    if (index === 2) {
      platformKey = "android";
    }
    if (index === 3) {
      platformKey = "stripe";
    }
    subscriptions.forEach((subscription) => {
      let planIndex = -1;
      switch (subscription.productId) {
        case "sportsbox_golf_lite_monthly":
        case "sportsbox_pro_lite_monthly":
          planIndex = 0;
          break;
        case "sportsbox_golf_lite_yearly":
        case "sportsbox_golf_lite_annually":
        case "sportsbox_pro_lite_yearly":
        case "sportsbox_pro_lite_annually":
          planIndex = 1;
          break;
        case "sportsbox_golf_plus_monthly":
          planIndex = 2;
          break;
        case "sportsbox_golf_plus_yearly":
          planIndex = 3;
          break;
        case "sportsbox_golf_premium_monthly":
        case "sportsbox_pro_premium_monthly":
          planIndex = 4;
          break;
        case "sportsbox_golf_premium_yearly":
        case "sportsbox_golf_premium_annually":
        case "sportsbox_pro_premium_yearly":
        case "sportsbox_pro_premium_annually":
          planIndex = 5;
          break;
        case "sportsbox_enterprise_master":
          if (
            (parseInt(subscription.amount) === 0 &&
              subscription.autoRenewal === false) ||
            (subscription.transactionId !== "" &&
              subscription.autoRenewal === false &&
              (parseInt(subscription.amount) === 100 ||
                parseInt(subscription.amount) === 200))
          ) {
            planIndex = 7;
          }
          if (subscription.autoRenewal) {
            planIndex = 6;
          }
          break;
        case "sportsbox_student_lite_monthly":
          planIndex = 8;
          break;
        case "sportsbox_student_lite_annually":
          planIndex = 9;
          break;
        default:
          break;
      }
      let start = new Date(parseInt(subscription.startDate));
      if (
        planIndex > -1 &&
        start >= range.startDate &&
        start <= moment(range.endDate).endOf("day").valueOf()
      ) {
        totalsResult[planIndex][platformKey]++;
        totalsResult[planIndex].overall++;

        let countTotal = true;
        if (plan == "COACH") {
          if (planIndex > 7) {
            countTotal = false;
          }
        } else if (plan == "STUDENT") {
          if (planIndex < 8) {
            countTotal = false;
          }
        } else if (plan != "ALL" && plan != subscription.productId) {
          countTotal = false;
        }
        if (countTotal) {
          totalsResult[10][platformKey]++;
          totalsResult[10].overall++;
        }
      }
    });
  });

  if (plan == "COACH") {
    totalsResult = [
      totalsResult[0],
      totalsResult[1],
      totalsResult[2],
      totalsResult[3],
      totalsResult[4],
      totalsResult[5],
      totalsResult[6],
      totalsResult[7],
      totalsResult[10],
    ];
  } else if (plan == "STUDENT") {
    totalsResult = [totalsResult[8], totalsResult[9], totalsResult[10]];
  } else if (plan != "ALL") {
    totalsResult = [totalsResult[pIndex[plan]]];
  }

  return totalsResult;
};

/**
 * Processes active subscription data (endDate > today)
 * Uses the same logic as processSubscriptions
 */
export const processActiveSubscriptions = (values, range, plan) => {
  return processSubscriptions(values, range, plan);
};

/**
 * Processes canceled subscription data
 */
export const processCanceledSubscriptions = (values, range, plan) => {
  let totalsCanceledResult = [
    {
      plan: "Pro Lite - Monthly",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Pro Lite - Annual",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Plus - Monthly",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Plus - Annual",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Premium - Monthly",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Premium - Annual",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Enterprise Master",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "3D Player - Monthly",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "3D Player - Annual",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
    {
      plan: "Total Accounts",
      elavon: 0,
      apple: 0,
      android: 0,
      stripe: 0,
      last24Hours: 0,
      last7Days: 0,
      lastMonth: 0,
      overall: 0,
    },
  ];

  const pIndex = {
    sportsbox_pro_lite_monthly: 0,
    sportsbox_pro_lite_annually: 1,
    sportsbox_pro_plus_monthly: 2,
    sportsbox_pro_plus_annually: 3,
    sportsbox_pro_premium_monthly: 4,
    sportsbox_pro_premium_annually: 5,
    sportsbox_enterprise_master: 6,
    sportsbox_student_lite_monthly: 7,
    sportsbox_student_lite_annually: 8,
  };

  values.forEach((subscriptions, index) => {
    let platformKey = "elavon";
    if (index === 1) {
      platformKey = "apple";
    }
    if (index === 2) {
      platformKey = "android";
    }
    if (index === 3) {
      platformKey = "stripe";
    }
    subscriptions.forEach((subscription) => {
      let planIndex = -1;
      switch (subscription.productId) {
        case "sportsbox_golf_lite_monthly":
        case "sportsbox_pro_lite_monthly":
          planIndex = 0;
          break;
        case "sportsbox_golf_lite_yearly":
        case "sportsbox_golf_lite_annually":
        case "sportsbox_pro_lite_yearly":
        case "sportsbox_pro_lite_annually":
          planIndex = 1;
          break;
        case "sportsbox_golf_plus_monthly":
          planIndex = 2;
          break;
        case "sportsbox_golf_plus_yearly":
          planIndex = 3;
          break;
        case "sportsbox_golf_premium_monthly":
        case "sportsbox_pro_premium_monthly":
          planIndex = 4;
          break;
        case "sportsbox_golf_premium_yearly":
        case "sportsbox_golf_premium_annually":
        case "sportsbox_pro_premium_yearly":
        case "sportsbox_pro_premium_annually":
          planIndex = 5;
          break;
        case "sportsbox_enterprise_master":
          if (
            parseInt(subscription.amount) !== 0 &&
            parseInt(subscription.amount) !== 1 &&
            parseInt(subscription.amount) !== 100 &&
            parseInt(subscription.amount) !== 200
          ) {
            planIndex = 6;
          }
          break;
        case "sportsbox_student_lite_monthly":
          planIndex = 8;
          break;
        case "sportsbox_student_lite_annually":
          planIndex = 9;
          break;
        default:
          break;
      }
      let start = new Date(parseInt(subscription.startDate));
      if (
        planIndex > -1 &&
        start >= range.startDate &&
        start <= moment(range.endDate).endOf("day").valueOf()
      ) {
        totalsCanceledResult[planIndex][platformKey]++;
        totalsCanceledResult[planIndex].overall++;

        let countTotal = true;
        if (plan == "COACH") {
          if (planIndex > 8) {
            countTotal = false;
          }
        } else if (plan == "STUDENT") {
          if (planIndex < 7) {
            countTotal = false;
          }
        } else if (plan != "ALL" && plan != subscription.productId) {
          countTotal = false;
        }
        if (countTotal) {
          totalsCanceledResult[9][platformKey]++;
          totalsCanceledResult[9].overall++;
        }
      }
    });
  });

  if (plan == "COACH") {
    totalsCanceledResult = [
      totalsCanceledResult[0],
      totalsCanceledResult[1],
      totalsCanceledResult[2],
      totalsCanceledResult[3],
      totalsCanceledResult[4],
      totalsCanceledResult[5],
      totalsCanceledResult[6],
      totalsCanceledResult[9],
    ];
  } else if (plan == "STUDENT") {
    totalsCanceledResult = [
      totalsCanceledResult[7],
      totalsCanceledResult[8],
      totalsCanceledResult[9],
    ];
  } else if (plan != "ALL") {
    totalsCanceledResult = [totalsCanceledResult[pIndex[plan]]];
  }

  return totalsCanceledResult;
};
